import * as Types from '../types/types.generated';

import { gql } from '@apollo/client';
export type KeywordTagFieldsFragment = { __typename?: 'Keyword', id: string, name: string, sortPriority?: number | null, descriptions?: Array<{ __typename?: 'TranslationObject', lang: Types.TranslationLang, translation: string }> | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', id: string, name: string }> };

export const KeywordTagFieldsFragmentDoc = gql`
    fragment KeywordTagFields on Keyword {
  id
  name
  descriptions {
    lang
    translation
  }
  vexClusters {
    id
    name
  }
  vkos {
    id
    name
  }
  sortPriority
}
    `;